import React from 'react'

import { ExpenseStatus } from 'core/domain/expenses/expenseStatus'

import Icon from 'common/components/general/Icon'

import { mapExpenseStatusWithColor, mapExpenseStatusWithIcon } from './ExpenseStatusMapping'

interface ExpenseIconProps {
  expenseStatus: ExpenseStatus
  isDuplicate?: boolean
}

export const ExpenseStatusIcon: React.FC<ExpenseIconProps> = ({ expenseStatus, isDuplicate }) => {
  const iconType = isDuplicate ? 'fal fa-clone' : mapExpenseStatusWithIcon.get(expenseStatus) ?? ''
  const iconClass = mapExpenseStatusWithColor.get(expenseStatus) ?? ''

  return <Icon type={iconType} className={`${iconClass} t-${expenseStatus}`} fontAwesome />
}

export default ExpenseStatusIcon
